<ng-template #iveriModal let-modal >
    <div class="modal-body">
        <app-iveri #ivery (iveriSuccess)="onIveriSuccess($event)" (iveriFail)="onIveriFail($event)" (iveriInit)="onIveriInit($event)"></app-iveri>
    </div>
</ng-template>
